import React from "react";
import { Modal } from "react-bootstrap";

const SimModal = ({ showModal, onHide, centered = true, size, title, children }) => {
  return (
    <Modal show={showModal} onHide={onHide} centered={centered} size={size}>
      <Modal.Body className="sim-modal-body">{children}</Modal.Body>
    </Modal>
  );
};

export default SimModal;
